module.exports = __webpack_public_path__ + "static/media/etch.1bba3f94.png";